import axios, { AxiosRequestConfig } from 'axios';

const baseApiUrl = 'api/v1/dashboard/header/search';

interface MyParam extends AxiosRequestConfig {
  searchParam?: string;
  shopId?: string | number;
}

export default class HeaderSearchService {
  public retrieve(searchStr?: string, shopId?: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const param: MyParam = {};
      param.searchParam = searchStr;
      if (shopId) {
        param.shopId = shopId;
      }

      axios
        .get(baseApiUrl, { params: param })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
